import { useState, type FormEvent } from "react";
import { PASSWORD_MIN_LENGTH } from "../constants";
import { Logo } from "../components/Logo";
import { ErrorState } from "../components/states";
import { useSession } from "../state/session";

export function Login() {
  const { translator, signIn, signUp } = useSession();
  const { t } = translator;

  const [mode, setMode] = useState<"signIn" | "signUp">("signIn");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await (mode === "signIn" ? signIn(email, password) : signUp(email, password));
    } catch (cause) {
      setError(cause);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth">
      <form className="auth__box" onSubmit={submit}>
        <div className="sidebar__brand">
          <Logo size={32} />
          <span>{t("common.appName")}</span>
        </div>
        <p className="muted">{t("common.tagline")}</p>

        {error !== null && <ErrorState error={error} />}

        <div className="field">
          <label htmlFor="email">{t("auth.email")}</label>
          <input
            id="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>

        <div className="field">
          <label htmlFor="password">{t("auth.password")}</label>
          <input
            id="password"
            type="password"
            autoComplete={mode === "signIn" ? "current-password" : "new-password"}
            required
            minLength={mode === "signUp" ? PASSWORD_MIN_LENGTH : undefined}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
          {mode === "signUp" && (
            <small className="muted">{t("auth.passwordHint", { min: PASSWORD_MIN_LENGTH })}</small>
          )}
        </div>

        <button className="btn btn--primary" type="submit" disabled={busy}>
          {busy ? t("common.loading") : t(mode === "signIn" ? "auth.signIn" : "auth.signUp")}
        </button>

        <button
          className="btn btn--ghost btn--small"
          type="button"
          onClick={() => setMode(mode === "signIn" ? "signUp" : "signIn")}
        >
          {t(mode === "signIn" ? "auth.signUp" : "auth.signIn")}
        </button>
      </form>
    </div>
  );
}
